export default (el) => ({
  id: Number(el.ChargeId),
  accountId: Number(el.SubscrId),
  name: String(el.PeriodName), // период
  amount: Number(el.Amount), // начислено
  payment: Number(el.Payment), // оплачено
  debit: Number(el.AmountToPay), // сумма к оплате
  items: (el.ChargeDetails || []).map((item) => ({
    id: Number(item.ChargeDetailId),
    name: String(item.Name),
    value: String(item.Amount),
    amount: Number(item.Amount),
  })),
  getPaySum() {
    const sum = this.items.reduce((acc, item) => acc + Number(item.value), 0);
    return Number(sum.toFixed(2));
  },
  getDifference() {
    const paySum = this.getPaySum();
    return paySum - this.amount;
  },
  clearPayValues() {
    this.items.forEach((item) => {
      item.value = String(item.amount); // eslint-disable-line
    });
  },
});
